<template>
  <div>
    <!-- <table width="100%" border="0" cellspacing="0" cellpadding="10" bgcolor="#cccccc" class="table-con" align="center">
      <tr>
        <th width="15%">单位员工</th>
        <td colspan="10">{{tableForm['userString']}}</td>
      </tr>
      <tr>
        <th width="15%">时间</th>
        <td width="35%">{{tableForm['vacationBeginTime']}}~{{tableForm['vacationEndTime']}}</td>
        <th width="15%">事件类型</th>
        <td width="35%">{{tableForm['vacationType']}}</td>
      </tr>
      <tr>
        <th width="15%">天数</th>
        <td width="35%" v-if="tableForm['recordType'] == 1">+ {{tableForm['vacationDay']}}天</td>
        <td width="35%" v-else>- {{tableForm['vacationDay']}}天</td>
        <th width="15%">操作人</th>
        <td width="35%">{{tableForm['updateUserName']}}</td>
      </tr>
      <tr>
        <th width="15%">有效期</th>
        <td width="35%" v-if="tableForm['validBeginTime'] && tableForm['validEndTime']">{{tableForm['validBeginTime']}}~{{tableForm['validEndTime']}}</td>
        <td width="35%" v-else>-</td>
        <th width="15%"></th>
        <td width="35%"></td>
      </tr>
      <tr>
        <th width="15%">详细信息</th>
        <td colspan="10"></td>
      </tr>
      <tr>
        <th width="15%">原因</th>
        <td colspan="10">{{tableForm['vacationReason']}}</td>
      </tr>
      <tr>
        <th width="15%">备注</th>
        <td colspan="10">{{tableForm['checkRemark']}}</td>
      </tr>
      <tr>
        <th width="15%">附件文档</th>
        <td colspan="10"></td>
      </tr>
      <tr>
        <th width="15%">登记时间</th>
        <td colspan="10">{{tableForm['createTime']}}</td>
      </tr>
      <tr>
        <th width="15%">最后时间</th>
        <td colspan="10">{{tableForm['updateTime']}}</td>
      </tr>
    </table> -->

    <Table :rowListData="tableConfig[0]" :infoData="tableForm" />
  </div>

</template>
<script>
import Table from "../../hr/employeemanage/components/table"
import * as dictionaries from "@/api/zd/dictionaries"
export default {
  name: 'TableForm',
  data() {
    return {
      baFileMenuId: '',
      files: [],
      tableConfig: [{
        name:'详情',
        colum: [
          {label: "姓名", prop: "userString", span: '4'},
          {label: "时间", prop: "vacationTime"},
          {label: "事件类型", prop: "vacationType"},
          {label: "天数", prop: "vacationDays",endunit: "天"},
          {label: "操作人", prop: "updateUserName"},
          {label: "有效期", prop: "validTimes",isFull: true, span: '2'},
          {label: "详细信息", prop: "checkDetailString",isFull: true, span: '2'},
          {label: "原因", prop: "vacationReason",isFull: true, span: '2'},
          {label: "备注", prop: "checkRemark",isFull: true, span: '2'},
          {label: "附件文档", prop: "fileName",isFull: true, span: '2',  linkUrl: true, fileUrl: this.tableForm.fileNameData?this.tableForm.fileNameData.fileUrl:''},
          {label: "登记时间", prop: "createTime",isFull: true, span: '2'},
          {label: "最后时间", prop: "updateTime",isFull: true, span: '2'},
          {label: "核销附件", prop: "checkFileName",isFull: true, span: '2', linkUrl: true, fileUrl: this.tableForm.checkFileNameData?this.tableForm.checkFileNameData.fileUrl:''},
        ]
      }]
    }
  },
  components: {
    Table
  },
  props: {
    tableForm: {
      type: Object,
      required: true
    }
  },
  watch: {
    tableForm: {
      handler(newData, oldData) {
        this.dealData()
      }
    }
  },
  beforeMount() {
    this.dealData()
    
  },
  methods: {
    dealData() {
      this.tableForm['vacationTime'] = `${this.tableForm['vacationBeginTime']}至${this.tableForm['vacationEndTime']}`
      let vacationDays = this.tableForm['recordType'] == 1?`+${this.tableForm['vacationDay']}`:`-${this.tableForm['vacationDay']}`
      let validTimes = this.tableForm['validBeginTime'] != ''?`${this.tableForm['validBeginTime']}至${this.tableForm['validEndTime']}`:'-'
      this.$set(this.tableForm, 'vacationTime', `${this.tableForm['vacationBeginTime']}至${this.tableForm['vacationEndTime']}`)
      this.$set(this.tableForm, 'vacationDays', vacationDays)
      this.$set(this.tableForm, 'validTimes', validTimes)
      if(this.tableForm['checkDetails']['length'] > 0){
        let valueArray = []
        this.tableForm['checkDetails'].map(item => {
          valueArray.push(`${item['vacationTypeStr']}:${Number(item['days']).toFixed(2)}天`)
        })
        this.tableForm['checkDetailString'] = valueArray.join(',')
      }else{
        this.tableForm['checkDetailString'] = '-'
      }

      // 查询附件
      this.getFileMenuByName('假期管理')
      // 核销附件
      this.getFileMenuByName('假期核算')

    },
    getFileMenuByName(name) {
      dictionaries
        .getFileMenuByName({ fileMenuName: name }).then((res) => {
          this.baFileMenuId = res.data.data.id
          this.getFileName(res.data.data.id, name)
        })
        .catch((res) => {
          console.log(res);
        });      
    },

    getFileName(id, name) {
      let self = this
      let params = {
        fileOtherId: this.tableForm['id'],
        baFileMenuId: id
      }
      dictionaries.findFileByOtherId(params).then((res) => {
        if(res['data']['data']['length'] > 0){
          self.files = res.data.data
          switch(name) {
            case '假期管理':
                self.$set(self.tableForm, 'fileName', self.files[0]['fileName'])
                self.$set(self.tableForm, 'fileNameData', self.files[0])
              break;
            case '假期核算':
                self.$set(self.tableForm, 'checkFileName', self.files[0]['fileName'])
                self.$set(self.tableForm, 'checkFileNameData', self.files[0])
              break;
          }
          // self.tableForm['fileName'] = self.files[0]['fileName']
        }else{
          switch(name) {
            case '假期管理':
                self.$set(self.tableForm, 'fileName', '-')
                self.$set(self.tableForm, 'fileNameData', '')
              break;
            case '假期核算':
                self.$set(self.tableForm, 'checkFileName', '-')
                self.$set(self.tableForm, 'checkFileNameData', '')
              break;
          }
        }
      })        
    }
  }
}
</script>
<style lang="scss" scoped>
.table-con {
  border-collapse: collapse;
	margin-top: 5px;
  td{
    font-size: 13px;
    border: 0.5px solid #ccc;
    background-color:#ffffff;
    height:25px;
    line-height:150%;    
  }
  th{
    font-weight: 400;
    font-size: 13px;
    background-color:#ffffff;
    height:25px;
    line-height:150%;  
    border: 0.5px solid #ccc;
  }
}
.font-center{ text-align:center}
.btbg{background:#e9faff !important;}
.btbg1{background:#f2fbfe !important;}
.btbg2{background:#f3f3f3 !important;}
</style>